var data = [{
    id: 1,
    label: '首页',
    icon: 'mdi-home-outline ',
    path: '/',
    pid: 0,
    is_menu: true,
    children: [{
        id: 1001,
        label: '流程中心',
        path: '/Flow',
        pid: 1,
        children: [{
            id: 1010,
            label: '启动流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowMasterList',
            pid: 1001,
            children: []
          },
          {
            id: 1011,
            label: '待办流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessSteps',
            pid: 1001,
            children: []
          },
          {
            id: 1012,
            label: '草稿',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsDraft',
            pid: 1001,
            children: []
          },
          {
            id: 1013,
            label: '我发起的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsSelf',
            pid: 1001,
            children: []
          },
          {
            id: 1014,
            label: '我经办的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsHandled',
            pid: 1001,
            children: []
          },
        ]
      },
      {
        id: 1002,
        label: '内部邮件',
        path: '/mail/list',
        pid: 1,
      },
      {
        id: 1003,
        label: '通讯录',
        path: '/personnel/addressList',
        pid: 1,
      },
      {
        id: 1004,
        label: '首页内容',
        pid: 1,
        is_menu: false,
        children: [
          {
            id: 1004001,
            label: '隐藏顶部图片',
            pid: 1004,
          },
          {
            id: 1004002,
            label: '隐藏公司公文',
            pid: 1004,
          },
          {
            id: 1004003,
            label: '隐藏新闻',
            pid: 1004,
          },
          {
            id: 1004004,
            label: '隐藏邮件',
            pid: 1004,
          },
          {
            id: 1004005,
            label: '隐藏流程',
            pid: 1004,
          },
          {
            id: 1004006,
            label: '隐藏重大消息',
            pid: 1004,
          },
          {
            id: 1004007,
            label: '隐藏社区文化',
            pid: 1004,
          }
        ]
      },
    ]
  },
  {
    id: 28,
    label: '工作台',
    icon: 'mdi-eslint',
    path: '/staging',
    pid: 0,
    is_menu: true,
    children: [{
        id: 28001,
        label: '流程中心',
        path: '/Flow',
        pid: 28,
        children: [{
            id: 2800101,
            label: '启动流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowMasterList',
            pid: 28001,
            children: []
          },
          {
            id: 2800102,
            label: '待办流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessSteps',
            pid: 28001,
            children: []
          },
          {
            id: 2800103,
            label: '草稿',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsDraft',
            pid: 28001,
            children: []
          },
          {
            id: 2800104,
            label: '我发起的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsSelf',
            pid: 28001,
            children: []
          },
          {
            id: 2800105,
            label: '我经办的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsHandled',
            pid: 28001,
            children: []
          },
        ]
      },
      {
        id: 28002,
        label: '内部邮件',
        path: '/mail/list',
        pid: 28,
      },
      {
        id: 28003,
        label: '通信录',
        path: '/personnel/addressList',
        pid: 28,
      },
    ]
  },
  {
    id: 30,
    label: '驾驶舱',
    path: 'https://zb.city.51homemoney.com/smart-city-screen/',
    pid: 0,
  },
  {
    id: 15,
    label: '业务拓展',
    path: '',
    pid: 0,
    children: [{
      id: 15001,
      label: '价值信息',
      path: '/zhoaocf/ledger-list',
      pid: 15,
      children: [
      // {
      //   id: 15001001,
      //   label: '数据总览',
      //   path: '/zhoaocf/ledger-statistics',
      //   pid: 15001,
      // },
      {
        id: 15001002,
        label: '信息列表',
        path: '/zhoaocf/ledger-list',
        pid: 15001,
      }]
    },
      // {
      //   id: 15005,
      //   label: '权责流程',
      //   path: '/zhoaocf/process-list',
      //   pid: 15,
      //   children: [{
      //     id: 15005001,
      //     label: '项目流程',
      //     path: '/zhoaocf/process-list',
      //     pid: 15005,
      //   },{
      //     id: 15005002,
      //     label: '权责类别',
      //     path: '/zhoaocf/process-type',
      //     pid: 15005,
      //   }]
      // },
      {
        id: 15002,
        label: '项目业态',
        path: '/zhoaocf/type-list',
        pid: 15
      },
      {
        id: 15003,
        label: '项目分类',
        path: '/zhoaocf/category-list',
        pid: 15
      },
      {
        id: 15004,
        label: '拓展单位',
        path: '/zhoaocf/region-list',
        pid: 15
      }]
  },
  {
    id: 13,
    label: '流程管理',
    icon: 'mdi-eslint ',
    path: '/Flow',
    pid: 0,
    children: [{
        id: 13001,
        label: '流程类别',
        icon: 'mdi-eslint ',
        path: '/flow/FlowType',
        pid: 13,
        children: [

        ]
      },
      {
        id: 13004,
        label: '流程管理',
        icon: 'mdi-eslint ',
        path: '/flow/FlowMaster',
        pid: 13,
        children: [

        ]
      },
      {
        id: 13010,
        label: '业务管理',
        icon: 'mdi-eslint ',
        path: '/flow/FlowProfessionalType',
        pid: 13,
        children: [{
            id: 13010001,
            label: '业务类型',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProfessionalType',
            pid: 13010,
            children: [

            ]
          },
          {
            id: 13010002,
            label: '业务管理',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProfessionalWork',
            pid: 13010,
            children: [

            ]
          },
          {
            id: 13010003,
            label: '业务日志',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProfessionalWorkLog',
            pid: 13010,
            children: [

            ]
          },
        ]
      },
      // {
      //   id: 13002,
      //   label: '流程编辑',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowSheet',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13003,
      //   label: '角色设置',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/UserRole',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13020,
      //   label: '流程模型管理',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowModelList',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13005,
      //   label: '流程操作',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowView',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13006,
      //   label: '流程预览',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/BpmnView',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13021,
      //   label: '流程表单设计',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowFormDesign',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13007,
      //   label: 'ER模型',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/ER',
      //   pid: 13,
      //   children: []
      // },
      {
        id: 13008,
        label: '流程中心',
        icon: 'mdi-eslint ',
        path: '/flow/FlowMasterList',
        pid: 13,
        children: []
      },
      {
        id: 13015,
        label: '城服流程中心',
        icon: 'mdi-eslint ',
        path: '/flow/FlowMasterList?company=cf',
        pid: 13,
        children: []
      },
      {
        id: 13009,
        label: '办理中心',
        icon: 'mdi-eslint ',
        path: '/flow/FlowProcessSteps',
        pid: 13,
        children: []
      },
      {
        id: 13011,
        label: '流程报表',
        icon: 'mdi-eslint ',
        path: '/flow/FlowTimeoutReport',
        pid: 13,
        children: []
      },
      {
        id: 13012,
        label: '流程调度',
        icon: 'mdi-eslint ',
        path: '/flow/FlowAbnormal',
        pid: 13,
        children: [{
          id: 13012001,
          label: '异常流程',
          icon: 'mdi-eslint ',
          path: '/flow/FlowAbnormal',
          pid: 13012,
          children: []
        },{
          id: 13012002,
          label: '流程转移',
          icon: 'mdi-eslint ',
          path: '/flow/FlowDeploy',
          pid: 13012,
          children: []
        }, ]
      },
      {
        id: 13013,
        label: '旧流程查询',
        icon: 'mdi-eslint ',
        path: '/flow/FlowOldHistory',
        pid: 13,
        children: [{
          id: 13013001,
          label: '流程列表',
          icon: 'mdi-eslint ',
          path: '/flow/FlowOldHistory',
          pid: 13013,
          children: []
        }, ]
      },
      {
        id: 13014,
        label: '流程配置',
        icon: 'mdi-eslint ',
        path: '/flow/CompanySetting',
        pid: 13,
        children: [{
          id: 13014001,
          label: '分公司配置',
          icon: 'mdi-eslint ',
          path: '/flow/CompanySetting',
          pid: 13014,
          children: []
        }, ]
      },
    ]
  },
  {
    id: 17,
    label: '品质管理',
    icon: 'mdi-home-outline',
    path: '',
    pid: 0,
    is_menu: true,
    children: [{
        id: 17001,
        label: '到家巡检',
        icon: 'mdi-eslint ',
        pid: 17,
        children: [{
            id: 17001001,
            label: '主营巡检概况',
            path: '/cockpit/pda',
            pid: 17001,
          },
          {
            id: 17001014,
            label: '非主营概况',
            path: '/quality-pda/third-overview',
            pid: 17001,
            is_menu: false,
            children: [{
                id: 'quality-pda-third-overview',
                label: '非主营概况',
                pid: 17001014,
                path: '/quality-pda/third-overview',
              },
              {
                id: 'quality-pda-third-user-trail',
                label: '人员轨迹',
                pid: 17001014,
              }
            ]
          },
          {
            id: 17001015,
            label: '帐号管理',
            path: '/quality-pda/account',
            pid: 17001,
          },
          {
            id: 17001002,
            label: '地点管理',
            path: '/quality-pda/address',
            pid: 17001,
          },
          {
            id: 17001003,
            label: '任务管理',
            path: '/pda/equipment',
            pid: 17001,
          },
          {
            id: 17001004,
            label: '任务抽检',
            path: '/pda/check',
            pid: 17001,
          },
          {
            id: 17001005,
            label: '巡检管理',
            path: '/pda/inspection',
            pid: 17001,
          },
          {
            id: 17001006,
            label: '操作日记',
            path: '/pda/diary',
            pid: 17001,
          },
          {
            id: 17001007,
            label: '权限架构',
            path: '/quality-pda/department',
            pid: 17001,
          },
          {
            id: 17001008,
            label: '部门管理',
            path: '/pda/department',
            pid: 17001,
          },
          // {
          //   id: 17001009,
          //   label: '人员管理',
          //   path: '/pda/user',
          //   pid: 17001,
          // },
          {
            id: 17001016,
            label: '人员管理',
            path: '/quality-pda/user',
            pid: 17001,
          },
          {
            id: 17001010,
            label: '整改工单',
            path: '/pda/repair',
            pid: 17001,
          },
          {
            id: 17001011,
            label: '地图巡航',
            path: '/pda/map',
            pid: 17001,
          },
          {
            id: 17001012,
            label: '工牌设备',
            path: '/pda/deviceIndex',
            pid: 17001,
          },
          {
            id: 17001013,
            label: '工牌管理',
            path: '/pda/deviceUserIndex',
            pid: 17001,
          },
        ],
      },
      {
        id: 17002,
        label: '品质检查',
        path: '',
        pid: 17,
        children: [{
            id: 17002001,
            label: '检查分类',
            path: '/quality-check/category',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002001001,
                label: '查询',
                pid: 17002001
              },
              {
                id: 17002001002,
                label: '编辑',
                pid: 17002001
              },
              {
                id: 17002001003,
                label: '删除',
                pid: 17002001
              }
            ]
          },
          {
            id: 17002002,
            label: '检查模板',
            path: '/quality-check/template',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002002001,
                label: '查询',
                pid: 17002002
              },
              {
                id: 17002002002,
                label: '新增',
                pid: 17002002
              },
              {
                id: 17002002003,
                label: '编辑',
                pid: 17002002
              },
              {
                id: 17002002004,
                label: '删除',
                pid: 17002002
              },
              {
                id: 17002002005,
                label: '导入',
                pid: 17002002
              }
            ]
          },
          {
            id: 17002003,
            label: '年度计划',
            path: '/quality-check/schedule',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002003001,
                label: '查询',
                pid: 17002003
              },
              {
                id: 17002003002,
                label: '新增',
                pid: 17002003
              },
              {
                id: 17002003003,
                label: '查看/编辑',
                pid: 17002003
              },
              {
                id: 17002003004,
                label: '导入',
                pid: 17002003
              },
              {
                id: 17002003005,
                label: '复制',
                pid: 17002003
              },
              {
                id: 17002003006,
                label: '删除',
                pid: 17002003
              },
              {
                id: 17002003007,
                label: '管理',
                pid: 17002003
              },
              {
                id: 17002003008,
                label: '品质部计划权限',
                pid: 17002003
              },
              {
                id: 17002003009,
                label: '永都电梯计划权限',
                pid: 17002003
              },
              {
                id: 17002003010,
                label: '审计计划权限',
                pid: 17002003
              },
              {
                id: 17002003011,
                label: '迅华计划权限',
                pid: 17002003
              },
              {
                id: 17002003012,
                label: '华瑞计划权限',
                pid: 17002003
              }
            ]
          },
          {
            id: 17002006,
            label: '检查报告',
            path: '/quality-check/report',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002006001,
                label: '查询',
                pid: 17002006
              },
              {
                id: 17002006002,
                label: '新增',
                pid: 17002006
              },
              {
                id: 17002006003,
                label: '编辑',
                pid: 17002006
              },
              {
                id: 17002006004,
                label: '删除',
                pid: 17002006
              }
            ]
          },
          {
            id: 17002004,
            label: '检查记录',
            path: '/quality-check/record',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002004001,
                label: '查询',
                pid: 17002004
              },
              {
                id: 17002004002,
                label: '查看',
                pid: 17002004
              },
              {
                id: 17002004007,
                label: '编辑',
                pid: 17002004
              },
              {
                id: 17002004003,
                label: '生成整改计划',
                pid: 17002004
              },
              {
                id: 17002004004,
                label: '预览',
                pid: 17002004
              },
              {
                id: 17002004005,
                label: '导出',
                pid: 17002004
              },
              {
                id: 17002004006,
                label: '删除',
                pid: 17002004
              }
            ]
          },
          {
            id: 17002007,
            label: '整改记录',
            path: '/quality-check/repair',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002007001,
                label: '查询',
                pid: 17002007
              },
              {
                id: 17002007002,
                label: '审核',
                pid: 17002007
              },
              {
                id: 17002007003,
                label: '导出',
                pid: 17002007
              },
              {
                id: 17002007004,
                label: '删除',
                pid: 17002007
              }
            ]
          },
          {
            id: 17002005,
            label: '检查报表',
            path: '/quality-check/reports',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002005001,
                label: '战区品质检查指标执行情况统计',
                pid: 17002005
              },
              {
                id: 17002005002,
                label: '战区检查得分明细表',
                pid: 17002005
              },
              {
                id: 17002005003,
                label: '战区检查管家主任得分明细表',
                pid: 17002005
              },
              {
                id: 17002005004,
                label: '战区项目品质整改率',
                pid: 17002005
              },
              {
                id: 17002005005,
                label: '战区品质检查计划完成率',
                pid: 17002005
              },
              {
                id: 17002005006,
                label: '品质中心分析报表',
                pid: 17002005
              },
              {
                id: 17002005010,
                label: '整改工单未审核报表',
                pid: 17002005
              },
              {
                id: 17002005011,
                label: '整改工单未整改报表',
                pid: 17002005
              },
              {
                id: 17002005012,
                label: '品质检查项目年度汇总报表',
                pid: 17002005
              },
            ]
          },
        ]
      },
      // {
      //   id: 17005,
      //   label: '客户满意度',
      //   path: '',
      //   pid: 17,
      //   children: [{
      //     id: 17005001,
      //     label: '满意度明细',
      //     path: '/question/question_answer',
      //     pid: 17005,
      //   }, {
      //     id: 17005002,
      //     label: '参与调查房产',
      //     path: '/question/question_house',
      //     pid: 17005,
      //     is_menu: false,
      //     children: [
      //       // {
      //       //   id: 17005002001,
      //       //   pid: 17005002,
      //       //   label: '导出所有房产',
      //       // },
      //       // {
      //       //   id: 17005002002,
      //       //   pid: 17005002,
      //       //   label: '导出已有房产',
      //       // },
      //       {
      //         id: 17005002003,
      //         pid: 17005002,
      //         label: '导入',
      //       }
      //     ]
      //   }, {
      //     id: 17005003,
      //     label: '短信推送记录',
      //     path: '/question/question_sms',
      //     pid: 17005,
      //   }]
      // },
      {
        id: 17003,
        label: 'AI监控',
        path: '',
        pid: 17,
        children: [{
          id: 17003001,
          label: '设备管理',
          path: '/camera/device',
          pid: 17003,
        }, ]
      },
      {
        id: 17006,
        label: '400投诉',
        path: '',
        pid: 17,
        children: [{
          id: 17006001,
          label: '话务处理',
          path: '/complaint400/add',
          pid: 17006,
        }, {
          id: 17006002,
          label: '负责人配置',
          path: '/complaint400/permission-list',
          pid: 17006,
        },]
      },
    ],
  },
  {
    id: 19,
    label: '行政管理',
    icon: 'mdi-home-outline ',
    path: '',
    pid: 0,
    is_menu: true,
    children: [
      {
        id: 19001,
        pid: 19,
        label: '企业微信',
        children: [{
            id: 19001001,
            pid: 19001,
            label: '内部群管理',
            path: '/user-group/list',
            is_menu: false,
            children: [{
                id: 19001001001,
                pid: 19001001,
                label: '列表展示',
              },
              {
                id: 19001001002,
                pid: 19001001,
                label: '编辑',
              }
            ]
          },
          {
            id: 19001002,
            pid: 19001,
            label: '消息推送',
            path: '/user-group/send',
            is_menu: false,
            children: [{
                id: 19001002001,
                pid: 19001002,
                label: '消息推送',
              },
              {
                id: 19001002002,
                pid: 19001002,
                label: '所有人',
              }
            ]
          },
          {
            id: 19001003,
            pid: 19001,
            label: '消息管理',
            path: '/user-group/log'
          },
        ]
      },
      {
        id: 19002,
        pid: 19,
        label: '文件共享',
        children: [
          {
            id: 19002001,
            pid: 19002,
            label: '文件发布',
            path: '/share/add'
          },
          {
            id: 19002002,
            pid: 19002,
            label: '文件中心',
            path: '/share/list'
          },
          {
            id: 19002003,
            pid: 19002,
            label: '我的文件',
            path: '/share/user'
          },
          {
            id: 19002004,
            pid: 19002,
            label: '权限管理',
            path: '/share/department'
          }
        ]
      },
      {
        id : 19003,
        pid : 19,
        label : '法务案件管理' ,
        children : [
          { id : 19003001 , pid : 19003 , label : '案件统计' , path : '/law-case/case-analysis'},
          { id : 19003002 , pid : 19003 , label : '案件管理' , path : '/law-case/list'},
        ]
      },
      {
        id : 19004,
        pid : 19 ,
        label :'用工风险管控',
        children : [
          { id : 19004001 , pid : 19004 , label : '人事案件统计' , path : '/law-case/analysis'},
          { id : 19004002 , pid : 19004 , label : '意外事故管控' , path : '/law-case/accident'},
          { id : 19004003 , pid : 19004 , label : '劳动纠纷管控' , path : '/law-case/dispute'},
        ],
      },
      {
        id : 19006 ,
        pid : 19 ,
        label : '物业责任险管理',
        children: [
          { id : 19006002 , pid : 19006 , label : '物业责任险统计' , path : '/law-case/public_analysis'},
          { id : 19006001 , pid : 19006 , label : '物业责任险管理' , path : '/law-case/public_insure' , children : [
              {id : 19006001001 , pid : 19006001 , label : '撤销权限'} ,
              {id : 19006001002 , pid : 19006001 , label : '登记编辑权限'}
            ]},
        ],
      },
      {
        id : 19005 ,
        pid : 19 ,
        label : '法务资料管理' ,
        children: [
          { id : 19005001 , pid : 19005 , label : '案件类型管理' , path : '/law-case/cate' },
          { id : 19005002 , pid : 19005 , label : '保险公司管理' , path : '/law-case/insurer'},
          { id : 19005003 , pid : 19005 , label : '原被告管理' , path : '/law-case/defendants'},
          { id : 19005004 , pid : 19005 , label : '律所管理' , path : '/law-case/firm'},
          { id : 19005005 , pid : 19005 , label : '律师管理' , path : '/law-case/lawyer'},
          { id : 19005006 , pid : 19005 , label : '保险公司管理' , path : '/law-case/insurer'},
          { id : 19005007 , pid : 19005 , label : '公司管理' , path : '/law-case/company'},
          { id : 19005008 , pid : 19005 , label : '数据权限' , path : '/law-case/data_auth'},
          // { id : 19005007 , pid : 19005 , label : '资料管理' , path : '/law-case/file'}
        ]
      },
      {
        id : 19007 ,
        pid : 19 ,
        label : '计划管理' ,
        children: [
          { id : 19007001 , pid : 19007 , label : '计划管理列表' , path : '/plan-management/plan-list' },
        ]
      },
    ]
  },


  {
    id: 26,
    label: '协同办公',
    icon: '',
    path: '',
    pid: 0,
    is_menu: true,
    children: [{
        id: 26001,
        label: '公共信息',
        icon: 'mdi-eslint ',
        path: '',
        pid: 26,
        children: [{
            id: 26001004,
            label: '通讯录',
            icon: 'mdi-eslint ',
            path: '/personnel/addressList',
            pid: 26001,
          },
          {
            id: 26001001,
            label: '新闻公告',
            icon: 'mdi-eslint ',
            path: '/new/newList',
            pid: 26001,
          },
          {
            id: 26001002,
            label: '我的收文',
            icon: 'mdi-eslint ',
            path: '/notice/receiveList',
            pid: 26001,
          },
          {
            id: 26001003,
            label: '新闻管理',
            icon: 'mdi-eslint ',
            path: '/new/newManageList',
            pid: 26001,
          },
        ]
      },
      {
        id: 26002,
        label: '个人事务',
        icon: 'mdi-eslint ',
        path: '',
        pid: 26,
        children: [{
            id: 26002001,
            label: '内部邮件',
            icon: 'mdi-eslint ',
            path: '/mail/list',
            pid: 26002,
            is_menu: false,
            children: [{
                id: 26002001002,
                label: '邮件列表',
                pid: 26002001,
              },
              {
                id: 26002001001,
                label: '群发所有人',
                pid: 26002001,
              },
              {
                id: 26002001003,
                label: '首页显示其它系统未读数量',
                pid: 26002001,
              }
            ]
          },
          {
            id: 26002002,
            label: '我的发文',
            icon: 'mdi-eslint ',
            path: '/notice/sendList',
            pid: 26002,
          }
        ]
      },
      {
        id: 26003,
        label: '流程中心',
        path: '/Flow',
        pid: 26,
        children: [{
            id: 260031,
            label: '启动流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowMasterList',
            pid: 26003,
            children: []
          },
          {
            id: 260032,
            label: '待办流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessSteps',
            pid: 26003,
            children: []
          },
          {
            id: 260033,
            label: '草稿',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsDraft',
            pid: 26003,
            children: []
          },
          {
            id: 260034,
            label: '我发起的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsSelf',
            pid: 26003,
            children: []
          },
          {
            id: 260035,
            label: '我经办的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsHandled',
            pid: 26003,
            children: []
          },
        ]
      },
      {
        id: 26004,
        label: '项目基础管理',
        pid: 26,
        children: [
          {
            id: 26004001,
            label: '项目列表',
            path: '/project-location/list',
            pid: 26004
          },
          {
            id: 26004003,
            label: '权限管理',
            path: '/project-location/permission',
            pid: 26004
          }
        ]
      },
      {
        id: 26005,
        label: '合同管理',
        icon: 'mdi-eslint ',
        path: '/Contract',
        pid: 26,
        children: [
          {
            id: 26005001,
            label: '合同管理',
            icon: 'mdi-eslint ',
            path: '/Contract',
            pid: 26005,
            is_menu: true,
            children: [
              {
                id: 26005001001,
                label: '业务类型',
                icon: 'mdi-eslint ',
                path: '/Contract/Business',
                pid: 26005001,
                children: [{
                  id: 26005001001001,
                  label: '添加类型',
                  pid: 26005001001,
                },
                  {
                    id: 26005001001002,
                    label: '编辑类型',
                    pid: 26005001001,
                  },
                ]
              },
              {
                id: 26005001002,
                label: '组织架构',
                icon: 'mdi-eslint ',
                path: '/Contract/Area',
                pid: 26005001,
                children: [{
                  id: 26005001002001,
                  label: '添加区域',
                  pid: 26005001002,
                },
                  {
                    id: 26005001002002,
                    label: '编辑区域',
                    pid: 26005001002,
                  },
                  {
                    id: 26005001002003,
                    label: '删除区域',
                    pid: 26005001002,
                  },
                ]
              },
              {
                id: 26005001005,
                label: '合作伙伴',
                icon: 'mdi-eslint ',
                path: '/Contract/Partnership',
                pid: 26005001,
                children: [{
                  id: 26005001005001,
                  label: '添加合作伙伴',
                  pid: 26005001005,
                },
                  {
                    id: 26005001005002,
                    label: '编辑合作伙伴',
                    pid: 26005001005,
                  },
                  {
                    id: 26005001005003,
                    label: '删除合作伙伴',
                    pid: 26005001005,
                  },
                  {
                    id: 26005001005004,
                    label: '导入合作伙伴',
                    pid: 26005001005,
                  },
                ]
              },
              {
                id: 26005001003,
                label: '项目管理',
                icon: 'mdi-eslint ',
                path: '/Contract/ContractProject',
                pid: 26005001,
                children: [{
                  id: 26005001003001,
                  label: '项目导入',
                  pid: 26005001003,
                },
                  {
                    id: 26005001003002,
                    label: '项目导出',
                    pid: 26005001003,
                  },
                  {
                    id: 26005001003003,
                    label: '创建项目',
                    pid: 26005001003,
                  },
                  {
                    id: 26005001003004,
                    label: '修改项目',
                    pid: 26005001003,
                  },
                ]
              },
              {
                id: 26005001004,
                label: '合同登记',
                icon: 'mdi-eslint ',
                path: '/Contract',
                pid: 26005001,
                children: [
                  {
                  id: 26005001004004,
                  label: '合同导入',
                  pid: 26005001004,
                  },
                  {
                    id: 26005001004005,
                    label: '合同导出',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004001,
                    label: '合同创建',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004002,
                    label: '合同编辑',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004011,
                    label: '合同删除',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004003,
                    label: '合同续签',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004006,
                    label: '合同总价设置',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004007,
                    label: '合同起始设置',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004008,
                    label: '款项周期设置',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004009,
                    label: '月金额设置',
                    pid: 26005001004,
                  },
                  {
                    id: 26005001004010,
                    label: '合同停止设置',
                    pid: 26005001004,
                  },
                ]
              },
            ]
          },
          {
            id: 26005002,
            label: '财务管理',
            icon: 'mdi-eslint ',
            path: '/Contract/ContractFinance',
            pid: 26005,
            is_menu: true,
            children: [
              {
                id: 26005002001,
                label: '变动登记',
                icon: 'mdi-eslint ',
                path: '/Contract/ContractFinance',
                pid: 26005002,
                children: [
                  {
                    id: 26005002001001,
                    label: '审核权限',
                    pid: 26005002001,
                  },
                  {
                    id: 26005002001002,
                    label: '变动登记',
                    pid: 26005002001,
                  },
                ]
              },
              {
                id: 26005002002,
                label: '开票登记',
                icon: 'mdi-eslint ',
                path: '/Contract/ContractFinanceInvoice',
                pid: 26005002,
                children: [
                  {
                    id: 26005002002001,
                    label: '审核权限',
                    pid: 26005002002,
                  },
                  {
                    id: 26005002002002,
                    label: '开票登记',
                    pid: 26005002002,
                  },
                  {
                    id: 26005002002003,
                    label: '开票撤销',
                    pid: 26005002002,
                  },
                ]
              },
              {
                id: 26005002003,
                label: '收款登记',
                icon: 'mdi-eslint ',
                path: '/Contract/ContractFinanceIncome',
                pid: 26005002,
                children: [{
                  id: 26005002003001,
                  label: '审核权限',
                  pid: 26005002003,
                },
                  {
                    id: 26005002003002,
                    label: '收款登记',
                    pid: 26005002003,
                  },
                ]
              },
              {
                id: 26005002004,
                label: '收款记录',
                icon: 'mdi-eslint ',
                path: '/Contract/ContractFinanceArrears',
                pid: 26005002,
                children: [{
                  id: 26005002004001,
                  label: '普通红冲',
                  pid: 26005002004,
                },
                  {
                    id: 26005002004002,
                    label: '审核红冲',
                    pid: 26005002004,
                  },
                ]
              },
              {
                id : 26005002005 ,
                label: '收款计划',
                icon : 'mdi-eslint ',
                path : '/Contract/ContractPlan',
                pid : 26005002
              }
            ]
          },
          {
            id: 26005003,
            label: '报表管理',
            icon: 'mdi-eslint ',
            path: '/Contract/Receivables',
            pid: 26005,
            is_menu: true,
            children: [
              {
                id: 26005003005,
                label: '合同台账',
                icon: 'mdi-eslint ',
                path: '/Contract/ContractLedger',
                pid: 26005003,
                children: []
              },
              {
                id: 26005003001,
                label: '权责收入台账',
                icon: 'mdi-eslint ',
                path: '/Contract/Receivables2',
                pid: 26005003,
                children: []
              },
              {
                id: 26005003002,
                label: '已收款台账',
                icon: 'mdi-eslint ',
                path: '/Contract/ReceivedAccount',
                pid: 26005003,
                children: []
              },
              {
                id: 26005003004,
                label: '开票末回款',
                icon: 'mdi-eslint ',
                path: '/Contract/InvoiceUncollected',
                pid: 26005003,
                children: []
              },
              {
                id: 26005003003,
                label: '欠费账龄表',
                icon: 'mdi-eslint ',
                path: '/Contract/ArrearageAging',
                pid: 26005003,
                children: []
              },
              {
                id : 26005003008,
                label :'月结报表',
                icon : 'mdi-eslint' ,
                path :'/Contract/Statics',
                pid : 26005003,
                children : []
              },
              {
                id : 26005003006,
                label :'权责报表录入',
                icon : 'mdi-eslint' ,
                path :'/Contract/RightReport',
                pid : 26005003,
                children : []
              },
              {
                id : 26005003007,
                label :'权责报表',
                icon : 'mdi-eslint' ,
                path :'/Contract/RightReportTable',
                pid : 26005003,
                children : []
              }
            ]
          },
        ],
      }
    ]
  },
  {
    id: 16,
    label: '人力资源',
    icon: 'mdi-home-outline',
    path: '/hr-staff/index',
    pid: 0,
    is_menu: true,
    children: [
      // {
      //   id: 16001,
      //   label: '通讯录',
      //   icon: 'mdi-eslint ',
      //   path: '/Personnel/addressList',
      //   pid: 16,
      // },
      // {
      //   id: 16018,
      //   label: '人事总览',
      //   path: '/cockpit/desktop',
      //   pid: 16,
      // },
      // {
      //   id: 16004,
      //   label: '新视窗',
      //   icon: 'mdi-eslint',
      //   path: 'https://oa.gdzawy.com:8888/',
      //   pid: 16,
      // },
      {
        id: 16009,
        label: '员工管理',
        path: 'hr-staff',
        pid: 16,
        children: [{
            id: 16009001,
            label: '员工信息',
            path: '/hr-staff/index',
            pid: 16009,
          },
          {
            id: 16009002,
            label: '花名册',
            path: '/hr-staff/roster',
            pid: 16009,
          },
          {
            id: 16009003,
            label: '黑名单管理',
            path: '/hr-staff/black-list',
            pid: 16009,
          },
          {
            id: 16009004,
            label: '薪酬级别管理',
            path: '/hr-staff/level-list',
            pid: 16009,
          },
          {
            id: 16009005,
            label: '入职标准',
            path: '/hr-staff/join-standards-list',
            pid: 16009,
          },
          {
            id: 16009006,
            label: '员工变动明细',
            path: '/hr-staff/dept-hange-list',
            pid: 16009,
          },
        ]
      },
      {
        id: 16005,
        label: '排班管理',
        path: 'workclass',
        pid: 16,
        children: [{
            id: 16005001,
            label: '班次设置',
            path: '/workclass/class',
            pid: 16005,
            is_menu: false,
            children: [{
                id: 16005001001,
                label: '查询',
                pid: 16005001
              },
              {
                id: 16005001002,
                label: '新增',
                pid: 16005001
              },
              {
                id: 16005001003,
                label: '修改',
                pid: 16005001
              },
              {
                id: 16005001004,
                label: '复制',
                pid: 16005001
              },
              {
                id: 16005001005,
                label: '删除',
                pid: 16005001
              },
            ]
          },
          {
            id: 16005002,
            label: '排班管理',
            path: '/workclass/user',
            pid: 16005,
            is_menu: false,
            children: [{
                id: 16005002001,
                label: '查询',
                pid: 16005002
              },
              {
                id: 16005002002,
                label: '修改',
                pid: 16005002
              },
              {
                id: 16005002003,
                label: '删除',
                pid: 16005002
              },
              {
                id: 16005002004,
                label: '报审',
                pid: 16005002
              },
              {
                id: 16005002005,
                label: '导出',
                pid: 16005002
              },
            ]
          },
          {
            id: 16005003,
            label: '排班审核',
            path: '/workclass/check',
            pid: 16005,
          },
          {
            id: 16005004,
            label: '排班计划表',
            path: '/workclass/schedule',
            pid: 16005,
          }
        ]
      },
      {
        id: 16008,
        label: '考勤管理',
        path: 'workcheck',
        pid: 16,
        children: [{
            id: 16008001,
            label: '考勤机管理',
            path: '/workcheck/app-list',
            pid: 16008,
          },
          {
            id: 16008010,
            label: '新考勤机管理',
            path: '/attendance/machine',
            pid: 16008,
            children:[{
              id: 16008010001,
              label: '仅查看',
              pid: 16008010,
            },{
              id: 16008010002,
              label: '编辑所有',
              pid: 16008010,
            }]
          },
          {
            id: 16008002,
            label: '考勤设置',
            path: '/workcheck/set-list',
            pid: 16008,
          },
          {
            id: 16008006,
            label: '考勤部门',
            path: '/workcheck/department',
            pid: 16008,
          },
          {
            id: 16008003,
            label: '考勤记录',
            path: '/workcheck/work_check_record',
            pid: 16008,
          },
          {
            id: 16008004,
            label: '考勤维护',
            path: '/workcheck/work_check_maintenance',
            pid: 16008,
            children: [{
                id: 16008004008,
                label: '查询',
                pid: 16008004,
              },
              {
                id: 160080040010,
                label: '查看自己',
                pid: 16008004,
              },
              {
                id: 160080040011,
                label: '查看部门',
                pid: 16008004,
              },
              {
                id: 16008004001,
                label: '保存',
                pid: 16008004,
              },
              {
                id: 16008004002,
                label: '导入',
                pid: 16008004,
              },
              {
                id: 16008004003,
                label: '删除',
                pid: 16008004,
              },
              {
                id: 16008004004,
                label: '报审',
                pid: 16008004,
              },
              {
                id: 16008004005,
                label: '日记',
                pid: 16008004,
              },
              {
                id: 16008004006,
                label: '导出',
                pid: 16008004,
              },
              {
                id: 16008004007,
                label: '考勤流程',
                pid: 16008004,
              },
              {
                id: 16008004009,
                label: '编辑实际出勤、计划出勤、忘记签卡、迟到分钟、早退分钟',
                pid: 16008004,
              },
            ]
          },
          {
            id: 16008005,
            label: '考勤审核',
            path: '/workcheck/work_check_examine',
            pid: 16008,
            children: [{
                id: 16008005001,
                label: '查询',
                pid: 16008005,
              },
              {
                id: 16008005002,
                label: '审核通过',
                pid: 16008005,
              },
              {
                id: 16008005003,
                label: '审核不通过',
                pid: 16008005,
              },
              {
                id: 16008005004,
                label: '导出记录',
                pid: 16008005,
              },
            ]
          },
          {
            id: 16008007,
            label: '年休假',
            path: '/workcheck/work_check_annual',
            pid: 16008,
            children: [{
                id: 16008007001,
                label: '查询',
                pid: 16008007,
              },
              {
                id: 16008007002,
                label: '编辑',
                pid: 16008007,
              }
            ]
          },
          {
            id: 16008008,
            label: '年度调休假',
            path: '/workcheck/work_check_year',
            pid: 16008,
            children: [{
                id: 16008008001,
                label: '查询',
                pid: 16008008,
              },
              {
                id: 16008008002,
                label: '编辑',
                pid: 16008008,
              }
            ]
          }
        ]
      },
      {
        id: 16014,
        label: 'e考勤管理',
        path: '/workcheck/eWorkCheck',
        pid: 16,
        children: [{
            id: 16014001,
            label: '考勤点设置',
            path: '/workcheck/eWorkCheck',
            pid: 16014,
          },
          {
            id: 16014002,
            label: '员工列表',
            path: '/workcheck/eUserList',
            pid: 16014,
          },
          {
            id: 16014003,
            label: '考勤记录',
            path: '/workcheck/eWorkCheckRecord',
            pid: 16014,
          }
        ]
      },
      {
        id: 16006,
        label: '基础设置',
        path: 'hr-setting',
        pid: 16,
        children: [{
            id: 16006001,
            label: '岗位设置',
            path: '/hr-setting/post-setting',
            pid: 16006,
          },
          {
            id: 16006002,
            label: '族群管理',
            path: '/hr-setting/group',
            pid: 16006,
          },
          {
            id: 16006003,
            label: '职位管理',
            path: '/hr-setting/position',
            pid: 16006,
          },
          {
            id: 16006008,
            label: '职级设置',
            path: '/hr-setting/rank-setting',
            pid: 16006,
          },
          {
            id: 16006009,
            label: '银行管理',
            path: '/hr-setting/bank-setting',
            pid: 16006,
          },
          {
            id: 16006004,
            label: '社保管理',
            path: '/hr-setting/social-insurance',
            pid: 16006,
          },
          {
            id: 16006005,
            label: '公积金管理',
            path: '/hr-setting/fund-manage',
            pid: 16006,
          },
          {
            id: 16006006,
            label: '缴纳关系管理',
            path: '/hr-setting/pay-relation-manage',
            pid: 16006,
          },
          {
            id: 16006007,
            label: '法定单位',
            path: '/hr-setting/legal_unit',
            pid: 16006,
          },
        ]
      },
      {
        id: 16007,
        label: '薪酬管理',
        path: 'hr-salary',
        pid: 16,
        children: [{
            id: 16007001,
            label: '基数设置',
            path: '/hr-salary/basic-setting',
            pid: 16007,
            children: [{
                id: 16007001001,
                label: '查询',
                pid: 16007001,
              },
              {
                id: 16007001002,
                label: '编辑所有数据',
                pid: 16007001,
              },
              {
                id: 16007001003,
                label: '编辑部分数据',
                pid: 16007001,
              },
              {
                id: 16007001004,
                label: '保存操作',
                pid: 16007001,
              },
              {
                id: 16007001005,
                label: '导入',
                pid: 16007001,
              },
              {
                id: 16007001006,
                label: '导出',
                pid: 16007001,
              },
              {
                id: 16007001007,
                label: '基数项目管理',
                pid: 16007001,
              }
            ]
          },
          {
            id: 16007002,
            label: '薪酬设置',
            path: '/hr-salary/salary-setting',
            pid: 16007,
            children: [{
                id: 16007002001,
                label: '查询',
                pid: 16007002,
              },
              {
                id: 16007002002,
                label: '管理工资项',
                pid: 16007002,
              },
            ]
          },
          {
            id: 16007003,
            label: '填报管理',
            path: '/hr-salary/reporting-management',
            pid: 16007,
            children: [{
                id: 1600700301,
                label: '添加审批',
                path: '/hr-setup/reporting-import',
                pid: 16007003,
                children: [

                ],
              },
              {
                id: 1600700302,
                label: '审批明细台账',
                path: '/hr-setup/reporting-report',
                pid: 16007003,
                children: [

                ],
              },
              {
                id: 1600700303,
                label: '填报项设置',
                path: '/hr-setup/reporting-setting',
                pid: 16007003,
                children: [{
                    id: 160070030301,
                    label: '新增',
                    path: '/hr-setup/reporting-add',
                    pid: 1600700303,
                    children: [

                    ],
                  },
                  {
                    id: 160070030302,
                    label: '修改',
                    path: '/hr-setup/reporting-edit',
                    pid: 1600700303,
                    children: [

                    ],
                  },
                  {
                    id: 160070030303,
                    label: '删除',
                    path: '/hr-setup/reporting-del',
                    pid: 1600700303,
                    children: [

                    ],
                  }
                ],
              },
              {
                id: 1600700304,
                label: '明细台账',
                path: '/hr-setup/reporting-detail',
                pid: 16007003,
                children: [{
                  id: 160070030401,
                  label: '导出',
                  path: '/hr-setup/reporting-export',
                  pid: 1600700304,
                  children: [

                  ],
                }],
              }
            ],
          },
          {
            id: 16007004,
            label: '薪酬管理',
            path: '/hr-salary/salary-management-list',
            pid: 16007,
            children: [{
                id: 16007004001,
                label: '查询列表',
                pid: 16007004,
              },
              {
                id: 16007004002,
                label: '新增发放',
                pid: 16007004,
              },
              {
                id: 16007004003,
                label: '计算工资',
                pid: 16007004,
              },
              {
                id: 16007004004,
                label: '提交审批',
                path: '/hr-setup/reporting-sub',
                pid: 16007004,
              },
              {
                id: 16007004005,
                label: '删除',
                path: '/hr-setup/reporting-del',
                pid: 16007004,
              },
              {
                id: 16007004006,
                label: '复制',
                path: '/hr-setup/reporting-copy',
                pid: 16007004,
              },
              {
                id: 16007004007,
                label: '新增线下工资',
                pid: 16007004,
              },
              {
                id: 1600700401,
                label: '发放工资表',
                path: '/hr-salary/salary-management-details',
                pid: 16007004,
                children: [{
                    id: 160070040101,
                    label: '批量调整',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040102,
                    label: '重新计算',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040103,
                    label: '添加员工',
                    pid: 16007004,
                  },
                  {
                    id: 160070040104,
                    label: '检查员工',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040105,
                    label: '修改备注',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040106,
                    label: '删除',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040107,
                    label: '工资项调整',
                    pid: 1600700401,
                  },
                ],
              },

              {
                id: 1600700402,
                label: '审批工资列表',
                path: '/hr-salary/salary-management-report',
                pid: 16007004,
                children: [

                ],
              }
            ],
          },
          {
            id: 16007005,
            label: '月度检查',
            path: '/hr-salary/month-check',
            pid: 16007,
          },
          {
            id: 16007006,
            label: '薪酬明细',
            path: '/hr-salary/salary-details',
            pid: 16007,
          },
          {
            id: 16007007,
            label: '异动检查',
            path: '/hr-salary/cardinal-change',
            pid: 16007,
          },
          {
            id: 16007008,
            label: '补贴管理',
            path: '/hr-salary/subsidy-management',
            pid: 16007,
          },
          {
            id: 16007009,
            label: '分盘管理',
            path: '/hr-salary/salary-split',
            pid: 16007,
            children: [{
                id: 16007009001,
                label: '明细列表',
                pid: 16007009,
              },
              {
                id: 16007009004,
                label: '企业修改',
                pid: 16007009,
              },
              {
                id: 16007009002,
                label: '初次确认',
                pid: 16007009,
              },
              {
                id: 16007009003,
                label: '重复确认',
                pid: 16007009,
              }
            ]
          },
          {
            id: 16007010,
            label: '分盘订单列表',
            path: '/hr-salary/salary-split-order',
            pid: 16007,
            children: [{
              id: 16007010001,
              label: '明细列表',
              pid: 16007010,
            }
            ]
          },
          {
            id: 16007011,
            label: '线下工资管理',
            path: '/hr-salary/salary-offline',
            pid: 16007,
          },
        ]
      },
      {
        id: 16010,
        label: '奖惩管理',
        path: 'punishments',
        pid: 16,
        children: [{
            id: 16010001,
            label: '奖惩种类设置',
            path: '/punishments/type',
            pid: 16010,
            children: [{
                id: 16010001001,
                label: '查询列表',
                pid: 16010001,
              },
              {
                id: 16010001002,
                label: '新增奖惩类型',
                pid: 16010001,
              },
              {
                id: 16010001003,
                label: '修改奖惩类型',
                pid: 16010001,
              },
              {
                id: 16010001004,
                label: '删除奖惩类型',
                pid: 16010001,
              },
            ],
          },
          {
            id: 16010002,
            label: '奖惩管理',
            path: '/punishments/list',
            pid: 16010,
            children: [{
                id: 16010002001,
                label: '查询列表',
                pid: 16010002,
              },
              {
                id: 16010002002,
                label: '新增奖惩',
                pid: 16010002,
              },
              {
                id: 16010002003,
                label: '导出奖惩明细表',
                pid: 16010002,
              },
              {
                id: 16010002004,
                label: '导入',
                pid: 16010002,
              },
              {
                id: 16010002005,
                label: '查看流程',
                pid: 16010002,
              },
              {
                id: 16010002006,
                label: '修改奖惩记录',
                pid: 16010002,
              },
              {
                id: 16010002007,
                label: '发起流程',
                pid: 16010002,
              },
              {
                id: 16010002008,
                label: '删除奖惩记录',
                pid: 16010002,
              },
            ],
          },
        ]
      },
      {
        id: 16011,
        label: '人事报表',
        icon: 'mdi-eslint',
        path: '/personnelReport/index',
        pid: 16,
        is_menu: true,
        children: [{
          id: 16011001,
          label: '查看与导出',
          pid: 16011,
        }, ]
      },
      {
        id: 16012,
        label: '培训认证',
        path: '/study',
        pid: 16,
        children: [{
          id: 160120001,
          label: '培训计划',
          path: '/study/train-plan',
          pid: 16012,
          children: [{
              id: 160120001001,
              label: '查看',
              pid: 160120001,
            },
            {
              id: 160120001002,
              label: '编辑',
              pid: 160120001,
            },
            {
              id: 160120001003,
              label: '删除',
              pid: 160120001,
            },
          ]
        }, {
          id: 160120002,
          label: '计划审核',
          path: '/study/train-plan-pass',
          pid: 16012,
          children: [{
              id: 160120002001,
              label: '查看',
              pid: 160120002,
            },
            {
              id: 160120002002,
              label: '编辑',
              pid: 160120002,
            },
            {
              id: 160120002003,
              label: '删除',
              pid: 160120002,
            },
          ]
        }, {
          id: 160120003,
          label: '报名管理',
          path: '/study/train-application',
          pid: 16012,
          children: [{
              id: 160120003001,
              label: '查看',
              pid: 160120003,
            },
            {
              id: 160120003002,
              label: '编辑',
              pid: 160120003,
            },
            {
              id: 160120003003,
              label: '删除',
              pid: 160120003,
            },
          ]
        }, {
          id: 160120004,
          label: '培训管理',
          path: '/study/train-train',
          pid: 16012,
          children: [{
              id: 160120004001,
              label: '查看',
              pid: 160120004,
            },
            {
              id: 160120004002,
              label: '编辑',
              pid: 160120004,
            },
            {
              id: 160120004003,
              label: '删除',
              pid: 160120004,
            },
          ]
        }, ]
      },
      {
        id: 16013,
        label: '劳务公司管理',
        path: '/hr-setting/company',
        pid: 16,
        children: [{
          id: 160130001,
          label: '劳务公司登记',
          path: '/hr-setting/company',
          pid: 16013,
        }, ]
      },
      {
        id: 16015,
        label: '绩效管理',
        path: '',
        pid: 16,
        children: [
          {
            id: 160150001,
            label: '考核指标管理',
            path: '/performance/indicators',
            pid: 16015,
          }
        ]
      },
      {
        id: 10004,
        label: '操作员管理',
        icon: 'mdi-eslint',
        path: '/Config/OperatorSetting',
        pid: 16,
        is_menu: true,
        children: [{
            id: 10004001,
            label: '角色管理',
            pid: 10003,
          },
          {
            id: 10004002,
            label: '房产权限',
            pid: 10003,
          },
          {
            id: 10004003,
            label: '查看员工',
            pid: 10003,
          }
        ]
      },
      {
        id: 10003,
        label: '角色权限设置',
        icon: 'mdi-eslint',
        path: '/Config/RoleSetting',
        pid: 16,
        is_menu: true,
        children: [{
            id: 10003001,
            label: '添加角色',
            pid: 10003,
          },
          {
            id: 10003002,
            label: '编辑角色',
            pid: 10003,
          },
          {
            id: 10003003,
            label: '删除角色',
            pid: 10003,
          },
          {
            id: 10003004,
            label: '查看角色',
            pid: 10003,
          },
        ]
      },
      {
        id: 16017,
        label: '环卫',
        path: '/Oa/EnvironmentalList',
        pid: 16,
        children: [{
          id: 160170001,
          label: '数据导出',
          path: '/Oa/EnvironmentalList',
          pid: 16017,
        }, ]
      },
    ]
  },
  {
    id: 31,
    label: '在线学习',
    path: '/study/index',
    pid: 0,
    is_menu: true,
    children: [{
        id: 3101,
        label: '首页',
        path: '/study/index',
        pid: 31,
      },
      {
        id: 3105,
        label: '课程管理',
        path: '/study/lesson-list',
        pid: 31,
        children: [{
          id: 31050001,
          label: '课程管理',
          path: '/study/lesson-list',
          pid: 3105,
          children: [],
        }, {
          id: 31050002,
          label: '课程分类',
          path: '/study/course-category-list',
          pid: 3105,
          children: [],
        }]
      },
      {
        id: 3103,
        label: '我的学习',
        path: '/study/questionBank',
        pid: 31,
        children: [{
            id: 31030001,
            label: '我的必修课',
            path: '/study/required-course',
            pid: 3103,
            children: [],
          },
          {
            id: 31030002,
            label: '我的选修课',
            path: '/study/elective-courses',
            pid: 3103,
            children: [],
          },
          {
            id: 31030003,
            label: '我的考试',
            path: '/study/myExam-list',
            pid: 3103,
            children: [],
          },
        ]
      },
      {
        id: 3104,
        label: '学习班管理',
        path: '/study/requiredCourse-manage',
        pid: 31,
        children: [{
          id: 31040001,
          label: '必修课管理',
          path: '/study/requiredCourse-manage',
          pid: 3104,
          children: [],
        }, ]
      },
      {
        id: 3102,
        label: '考试管理',
        path: '/study/questionBank',
        pid: 31,
        children: [{
            id: 31020001,
            label: '题库管理',
            path: '/study/questionBank',
            pid: 3102,
            children: [],
          },
          {
            id: 31020002,
            label: '试卷管理',
            path: '/study/testPaper',
            pid: 3102,
            children: [],
          },
          {
            id: 31020004,
            label: '成绩查询',
            path: '/study/Exam-list',
            pid: 3102,
            children: [],
          },
          {
            id: 31020005,
            label: '报名审核',
            path: '/study/registration-review',
            pid: 3102,
            children: [],
          },
          {
            id: 31020003,
            label: '试卷批改',
            path: '/study/correct-list',
            pid: 3102,
            children: [],
          },
        ]
      }
    ]
  },
  {
    id: 32,
    label: '采购管理',
    path: '/procure/product-list',
    pid: 0,
    is_menu: true,
    children: [{
        id: 3201,
        label: '仓储管理',
        path: '/procure/product-list',
        pid: 32,
        children: [{
            id: 32010001,
            label: '物料管理',
            path: '/procure/product-list',
            pid: 3201,
            children: [],
          },
          {
            id: 32010002,
            label: '物料分类',
            path: '/procure/product-category-list',
            pid: 3201,
            children: [],
          },
          {
            id: 32010003,
            label: '出入库记录',
            path: '/procure/storagelog-list',
            pid: 3201,
            children: [],
          },
          {
            id: 32010004,
            label: '仓库管理',
            path: '/procure/warehouse-list',
            pid: 3201,
            children: [],
          },
          {
            id: 32010005,
            label: '仓库绑定管理',
            path: '/procure/warehouse-bind-list',
            pid: 3201,
            children: [],
          },
        ],
      },
      {
        id: 3205,
        label: '供应商管理',
        path: '/procure/supplier-list',
        pid: 32,
        children: [{
          id: 32050002,
          label: '区域分类',
          path: '/procure/supplier-class',
          pid: 3205,
          children: [],
        },{
          id: 32050001,
          label: '供应商管理',
          path: '/procure/supplier-list',
          pid: 3205,
          children: [],
        }],
      },
      {
        id: 3206,
        label: '采购报价',
        path: '/procure/procurementQuotation',
        pid: 32,
        children: [{
          id: 32060001,
          label: '采购报价单',
          path: '/procure/procurementQuotation',
          pid: 3206,
          children: [],
        }],
      },
    ]
  },
  {
    id: 29,
    label: '预算管理',
    icon: 'mdi-home-outline',
    path: '/budget/account-list',
    pid: 0,
    is_menu: true,
    children: [{
        id: 29001,
        label: '预算管理',
        path: 'budget',
        pid: 29,
        children: [{
            id: 29001001,
            label: '科目代码',
            icon: 'mdi-eslint',
            path: '/budget/account-list',
            pid: 29001,
            children: [{
                id: 29001001001,
                label: '查看',
                pid: 29001001,
              },
              {
                id: 29001001002,
                label: '导入科目',
                pid: 29001001,
              },
            ]
          },
          {
            id: 29001002,
            label: '预算计划预览',
            icon: 'mdi-eslint',
            path: '/budget/plan-task',
            pid: 29001,
            children: [{
                id: 29001002001,
                label: '查看',
                pid: 29001002,
              },
              {
                id: 29001002002,
                label: '导入预算计划',
                pid: 29001002,
              },
            ]
          }, {
            id: 29001003,
            label: '预算计划',
            icon: 'mdi-eslint',
            path: '/budget/budget-plan',
            pid: 29001,
            children: [{
                id: 29001003003,
                label: '查看',
                pid: 29001003,
              },
              {
                id: 29001003001,
                label: '删除',
                pid: 29001003,
              },
              {
                id: 29001003002,
                label: '强制删除',
                pid: 29001003,
              },
            ]
          },
          {
            id: 29001004,
            label: '预算调整',
            icon: 'mdi-eslint',
            path: '/budget/adjust-apply',
            pid: 29001,
            is_menu: true,
          },
          {
            id: 29001005,
            label: '费用报销',
            icon: 'mdi-eslint',
            path: '/budget/expense-apply',
            pid: 29001,
            is_menu: true,
          },
          {
            id: 29001006,
            label: '月度资金计划',
            icon: 'mdi-eslint',
            path: '/budget/budget-apply',
            pid: 29001,
            is_menu: true,
          },
          {
            id: 29001007,
            label: '费用报销统计表',
            icon: 'mdi-eslint',
            path: '/budget/expense-apply-summary',
            pid: 29001,
            children: [{
              id: 29001007001,
              label: '导出',
              pid: 29001007,
            }, ]
          },
          {
            id: 29001008,
            label: '费用申请统计表',
            icon: 'mdi-eslint',
            path: '/budget/budget-apply-summary',
            pid: 29001,
            children: [{
              id: 29001008001,
              label: '导出',
              pid: 29001008,
            }, ]
          },
        ]
      },
      {
        id: 29003,
        label: '个人借支',
        path: '/budget/borrowing',
        pid: 29,
        is_menu: true,
        children: [{
            id: 290030001,
            label: '查看所有人',
            pid: 29003,
          },
          {
            id: 290030002,
            label: '查看自己',
            pid: 29003,
          },
        ]
      },
      {
        id: 29002,
        label: '预算报表',
        icon: 'mdi-eslint',
        path: '/budget/expense-apply-summary',
        pid: 29,
        is_menu: true,
        children: [{
          id: 29002001,
          label: '导出',
          pid: 29002,
        }, ]
      },
      {
        id: 29004,
        label: '预算编辑',
        icon: 'mdi-eslint',
        path: '',
        pid: 29,
        children: [
          {
            id: 29004001,
            label: '项目预算模板',
            icon: 'mdi-eslint',
            path: '/center/index1',
            pid: 29004,
          },
          {
            id: 29004002,
            label: '职能预算模板',
            icon: 'mdi-eslint',
            path: '/center/index2',
            pid: 29004,
          },
          {
            id: 29004003,
            label: '市场预算模板',
            icon: 'mdi-eslint',
            path: '/center/index3',
            pid: 29004,
          },
          {
            id: 29004004,
            label: '项目预算汇总',
            icon: 'mdi-eslint',
            path: '/center/report1',
            pid: 29004,
          },
          {
            id: 29004005,
            label: '职能预算汇总',
            icon: 'mdi-eslint',
            path: '/center/report2',
            pid: 29004,
          },
          {
            id: 29004006,
            label: '市场预算汇总',
            icon: 'mdi-eslint',
            path: '/center/report3',
            pid: 29004,
          },
          {
            id: 29004007,
            label: '分项目汇总',
            icon: 'mdi-eslint',
            path: '/center/report-multi',
            pid: 29004,
          },
          {
            id: 29004008,
            label: '权限管理',
            icon: 'mdi-eslint',
            path: '/center/permission',
            pid: 29004,
          },
          {
            id: 29004009,
            label: '基础数据导入',
            icon: 'mdi-eslint',
            path: '/center/base',
            pid: 29004,
          }
        ]
      }
    ]
  },
  {
    id: 10,
    label: '设置',
    icon: 'mdi-eslint ',
    path: '/Config/Config', // /mb
    pid: 0,
    children: [{
        id: 10001,
        label: '基础设置',
        icon: 'mdi-eslint',
        path: '/Config/Config', // /mb
        pid: 10,
      },
      {
        id: 2,
        label: '项目',
        icon: 'mdi-archive-outline ',
        path: '/pindex/index',
        pid: 10,
        children: [{
            id: 2001,
            label: '项目列表',
            path: '/pindex/index',
            pid: 2,
            children: [{
                id: 2001001,
                label: '添加项目',
                pid: 2001,
              },
              {
                id: 20010017,
                label: '账龄费项设置',
                pid: 2001,
              },
              {
                id: 2001002,
                label: '查看',
                pid: 2001,
              },
              {
                id: 2001003,
                label: '抄表导入水电费',
                pid: 2001,
              },
              {
                id: 2001004,
                label: '抄表导入水电费-设置费用',
                pid: 2001,
              },
              {
                id: 2001005,
                label: '抄表导入水电费-导入水电费',
                pid: 2001,
              },
              {
                id: 2001006,
                label: '抄表导入水电费-模板下载',
                pid: 2001,
              },
              {
                id: 2001017,
                label: '抄表导入水电费-生成订单',
                pid: 2001,
              },
              {
                id: 2001007,
                label: '抄表导入水电费-下载',
                pid: 2001,
              },
              {
                id: 2001008,
                label: '抄表导入水电费-删除',
                pid: 2001,
              },
              {
                id: 2001009,
                label: '绑定收费项生成订单',
                pid: 2001,
              },
              {
                id: 2001010,
                label: '绑定收费项生成订单-绑定收费项',
                pid: 2001,
              },
              {
                id: 2001011,
                label: '绑定收费项生成订单-生成订单',
                pid: 2001,
              },
              {
                id: 2001012,
                label: '绑定收费项生成订单-修改绑定收费项',
                pid: 2001,
              },
              {
                id: 2001013,
                label: '绑定收费项生成订单-删除',
                pid: 2001,
              },
              {
                id: 2001014,
                label: '修改项目',
                pid: 2001,
              },
              {
                id: 2001015,
                label: '删除项目',
                pid: 2001,
              },
              {
                id: 2001016,
                label: '费项设置',
                pid: 2001,
              },
            ]
          },
          {
            id: 3002005,
            label: '项目管理',
            icon: 'mdi-archive-outline ',
            path: '/pindex/zone',
            pid: 2,
          },
          // {
          //   id: 2003,
          //   label: '新视窗导入',
          //   path: '/pindex/xsc/xsc',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2004,
          //   label: '应收对账',
          //   path: '/pindex/xsc/receivable',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2005,
          //   label: '欠费对账',
          //   path: '/pindex/xsc/arrearage',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2006,
          //   label: '收费对账',
          //   path: '/pindex/xsc/charge',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2007,
          //   label: '同步修改',
          //   path: '/pindex/xsc/with',
          //   pid: 2,
          //   is_menu: true,
          // },
          {
            id: 2008,
            label: '项目分类',
            path: '/pindex/belong',
            pid: 2,
            is_menu: true,
          },
          {
            id : 2009 ,
            label : '地区管理' ,
            path : '/pindex/place',
            pid : 2 ,
            is_menu : true
          }
        ]
      },
      {
        id: 7006,
        label: '菜单管理',
        path: '/Jindex/MenuTree',
        pid: 10,
        is_menu: true,
      },
      {
        id: 10002,
        label: '生成目录',
        icon: 'mdi-eslint ',
        path: '/Config/CreateTreeMenu', //
        pid: 10,
      },
      {
        id: 10006,
        label: '运维管理',
        icon: 'mdi-eslint',
        path: '/Log/LogList', // /mb
        pid: 10,
        children: [{
            id: 10006001,
            label: '前端日志',
            icon: 'mdi-eslint',
            path: '/Log/LogList', // /mb
            pid: 10006,
            is_menu: true,
          },
          {
            id: 10006002,
            label: '抽检配置',
            icon: 'mdi-eslint',
            path: '/Butler/TaskUserConfig', // /mb
            pid: 10006,
            is_menu: true,
          },
        ]
      },
      {
        id: 6002,
        label: '操作日记',
        path: '/operation/log',
        pid: 10,
        is_menu: true,
        children: [{
          id: 6002001,
          label: '添加组织',
          pid: 6002,
        }, ]
      },
      {
        id: 9001,
        label: '小程序管理',
        path: '/Applets/appletslist',
        pid: 10,
        is_menu: true,
      },
      {
        id: 9002,
        label: '首页装修',
        path: '/Applets/appletsHome',
        pid: 10,
        is_menu: true,
      },
      {
        id: 9003,
        label: '支付配置',
        path: '/Applets/appletsclass',
        pid: 10,
        is_menu: true,
      },
      {
        id: 9004,
        label: 'CMS',
        path: '/Cms/',
        pid: 10,
        children: [{
            id: 9004001,
            label: '栏目列表',
            path: '/Cms/CmsChannel',
            pid: 9004,
            children: [

            ],
          },
          {
            id: 9004002,
            label: '内容列表',
            path: '/Cms/CmsArticle',
            pid: 9004,
            children: [

            ],
          },
        ],
      },
      // {
      //   id: 11005,
      //   label: '考勤管理',
      //   icon: 'mdi-eslint ',
      //   path: '/Oa/Attendance/list',
      //   pid: 23,
      //   children: [{
      //     id: 11005001,
      //     label: '考勤设置',
      //     icon: 'mdi-home-outline ',
      //     path: '/Oa/Attendance/set',
      //     pid: 11005,
      //     is_menu: true
      //   },{
      //     id: 11005002,
      //     label: '考勤列表',
      //     icon: 'mdi-home-outline ',
      //     path: '/Oa/AttendanceList',
      //     pid: 11005,
      //     is_menu: true
      //   }]
      // },
      {
        id: 9005,
        label: '人事管理',
        path: '/hr-setup/',
        pid: 10,
        children: [
          //   {
          //   id: 9005001,
          //   label: '公司管理',
          //   path: '/hr-setup/company',
          //   pid: 9005,
          //   children: [{
          //     id: 9005101,
          //     label: '公司设置',
          //     path: '/hr-setup/company-edit',
          //     pid: 9005001,
          //     children: [
          //
          //     ],
          //   }, ],
          // },
          // {
          //   id: 9005002,
          //   label: '部门管理',
          //   path: '/hr-setup/department',
          //   pid: 9005,
          //   children: [{
          //     id: 9005201,
          //     label: '部门设置',
          //     path: '/hr-setup/department-edit',
          //     pid: 9005002,
          //     children: [
          //
          //     ],
          //   }, ],
          // },
          {
            id: 9005003,
            label: '部门定编',
            path: '/hr-setup/business',
            pid: 9005,
            children: [{
                id: 9005301,
                label: '批量定编人数查询',
                path: '/hr-setup/business-all',
                pid: 9005003,
                children: [

                ],
              },
              {
                id: 9005303,
                label: '批量定编人数设置',
                path: '/hr-setup/business-edit',
                pid: 9005003,
                children: [

                ],
              },
              {
                id: 9005304,
                label: '批量定编人数导入',
                path: '/hr-setup/business-import',
                pid: 9005003,
                children: [

                ],
              },
            ],
          },
          {
            id: 9005004,
            label: '部门设置',
            path: '/hr-setup/department-setting',
            pid: 9005,
            children: [{
              id: 9005004001,
              label: '部门设置',
              path: '/hr-setup/department-setting',
              pid: 9005004,
              children: [

              ],
            }, ],
          },
          // {
          //   id: 9005005,
          //   label: '部门编辑',
          //   path: '/hr-setup/department-setting-detail',
          //   pid: 9005,
          //   children: [{
          //     id: 9005005001,
          //     label: '部门编辑',
          //     path: '/hr-setup/department-setting-detail',
          //     pid: 9005004,
          //     children: [
          //
          //     ],
          //   },
          //   ],
          // },
        ],
      },
      {
        id: 9006,
        label: '集团服务',
        path: '/',
        pid: 10,
        children: [{
            id: 9006001,
            label: '集团服务',
            path: '/study/red-envelopes',
            pid: 9006,
            children: [

            ],
          },
          {
            id: 9006002,
            label: '发放红包',
            path: 'https://flow.gdzawy.com:9001/readback/zhongao.html',
            pid: 9006,
            children: [],
          },
        ],
      },
    ],
  },

  // 合同管理
  {
    id: 14,
    label: '合同管理',
    icon: 'mdi-eslint ',
    path: '/',
    pid: 0,
    children: [{
      id: 14001,
      label: '设置管理',
      icon: 'mdi-eslint ',
      path: '/contract/cust-list',
      pid: 14,
      children: [{
          id: 14001001,
          label: '客户列表',
          icon: 'mdi-eslint ',
          path: '/contract/cust-list',
          pid: 14001,
          is_menu: true
        },
        {
          id: 14001002,
          label: '分类列表',
          icon: 'mdi-eslint ',
          path: '/contract/cate-list',
          pid: 14001,
          is_menu: true
        },
        {
          id: 14001003,
          label: '业户类型列表',
          icon: 'mdi-eslint ',
          path: '/contract/business-list',
          pid: 14001,
          is_menu: true
        },
        // {
        //   id: 14001004,
        //   label: '字典列表',
        //   icon: 'mdi-eslint ',
        //   path: '/contract/field-list',
        //   pid: 14001,
        //   is_menu: true
        // },
        // {
        //   id: 14001005,
        //   label: '模板列表',
        //   icon: 'mdi-eslint ',
        //   path: '/contract/template-list',
        //   pid: 14001,
        //   is_menu: true
        // },
      ]
    },{
      id: 14002,
      label: '合同管理',
      icon: 'mdi-eslint ',
      path: '/contract/contract-list',
      pid: 14,
      children: [{
          id: 14002001,
          label: '合同列表',
          icon: 'mdi-eslint ',
          path: '/contract/contract-list',
          pid: 14002,
          is_menu: true
        },
      ]
    },{
      id: 14003,
      label: '财务汇总',
      icon: 'mdi-eslint ',
      pid: 14,
      children: [{
        id: 14003001,
        label: '汇总报表',
        path: '/contract/finance',
        pid: 14003,
        is_menu: true
      },
      {
        id: 14003002,
        label: '应收应付管理',
        path: '/contract/payment',
        pid: 14003,
        is_menu: true
      },
      {
        id: 14003003,
        label: '收付记录',
        path: '/contract/payment-log',
        pid: 14003,
        is_menu: true
      }
      ]
    }]
  },
  {
    id: 21,
    label: '工程管理',
    path: '',
    pid: 0,
    is_menu: true,
    children: [
      {
        id: 21009,
        label: '甲方管理',
        path: '/score',
        pid: 21,
        children: [{
          id: 21009001,
          label: '人员管理',
          pid: 21009,
          is_menu: true,
          children: [{
            id: 21009001001,
            label: '用户信息',
            path: '/score/user',
            pid: 21009001,
          },
            {
              id: 21009001002,
              label: '角色管理',
              path: '/score/user-role',
              pid: 21009001,
            },
            {
              id: 21009001003,
              label: '用户使用情况',
              path: '/score/user-report',
              pid: 21009001,
            }
          ]
        },
          {
            id: 21009002,
            label: '评分管理',
            pid: 21009,
            is_menu: true,
            children: [{
              id: 21009002001,
              label: '评分表',
              path: '/score/comment',
              pid: 21009002,
            },
              {
                id: 21009002002,
                label: '评分模板管理',
                path: '/score/comment-template',
                pid: 21009002,
              },
            ]
          },
          {
            id: 21009003,
            label: '工单管理',
            path: '/score/work-order',
            pid: 21009,
          },
          {
            id: 21009004,
            label: '满意度调查',
            path: '',
            pid: 21009,
            is_menu: true,
            children: [
              {
                id: 21009004001,
                label: '调查列表',
                path: '/score/survey-list',
                pid: 21009004,
              },
              {
                id: 21009004002,
                label: '模板管理',
                path: '/score/survey-template',
                pid: 21009004,
              }
            ]
          },
          {
            id: 21009005,
            label: '报事报修',
            path: '',
            pid: 21009,
            is_menu: true,
            children: [
              {
                id: 21009005001,
                label: '工单列表',
                path: '/repair/list',
                pid: 21009005,
              },
              {
                id: 21009005002,
                label: '权限管理',
                path: '/repair/permission',
                pid: 21009005,
              }
            ]
          },
          {
            id: 21009006,
            label: '项目管理',
            path: '/score/project',
            pid: 21009,
          },
        ]
      }
    ]
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/assets/js/tree.js